import { useContext, useEffect } from 'react';
import { SDKContext } from '../context/sdk';

export function useGetToggleViews(design: any, attached: boolean) {
  const { setError, setViewToggles, viewToggles } = useContext(SDKContext);

  useEffect(() => {
    console.log('Loading viewToggles');
    if (!attached) {
      return;
    }
    setTimeout(() => {
      design?.getViewToggle()
        .then((result: any) => setViewToggles(result))
        .catch((err: any) => {
          console.warn(err);
          setError('An error occurred while loading the view toggles.');
        });
    }, 3000); // needed to set properly! a bug?
  }, [
    attached,
    design,
    setError,
    setViewToggles
  ]);
  
  return { viewToggles };
  }